<template>
  <div class="row">
    <div class="col-md-12 select-customer-properties-container">
      <select ref="select" class="form-control form-control-lg customer-properties-tom-selector"
              :placeholder="'Select ' +propertyComputed.property_name.toLowerCase()" multiple>
      </select>
    </div>
  </div>
</template>

<script>

import {EventBus} from "@/events/event-bus";
import TomSelect from 'tom-select'
import {property} from "underscore";

export default {
    name: "CustomerPropertiesDropdown",
    data() {
        return {
            select: null,
      selected: null
        }
    },
    props: {
        customerId: {
            required: true
        },
    'property': {
      required: true
    }
  },
  computed: {
    propertyComputed() {
      return this.property
    }
    },
    methods: {
        initializeDropdown() {
            let vm = this;
            this.select = new TomSelect(this.$refs['select'], {
                preload: true,
                maxOptions: 100,
                searchField: ['value'],
                valueField: 'customer_property_id',
                closeAfterSelect: true,
                duplicates: true,
                highlight: false,
                persist: false,
                allowEmptyOption: true,
                load: function (query, callback) {
          callback(vm.property.customer_properties)
                },
                plugins: {
                    'dropdown_header': {
                        html() {
                            return `<div class="create_new_property_js">
                                          <a class="create_new_property_js_link property_popup_${vm.property.property_id}" id="add_property" href="#" data-toggle="modal" data-target="#property_popup_${vm.property.property_id}" style="color: #2E4051; text-decoration: none;padding: 7px 9px 3px -2px;">
                                              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11 5H9V9H5V11H9V15H11V11H15V9H11V5ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#03A9F4"/> </svg>
                                              <span style="position: relative; top: -5px;left: 5px;">New ${vm.property.property_name}</span>
                                          </a>
                                      </div>`
                        },
                    },
                },
                openOnFocus: true,
                render: {
                    option: function (item, escape) {
                        return `<div class="col-12">${unescape(item.value)}</div>`
                    },
                    item: function (data, escape) {
                        return `<div class="col-12">${unescape(data.value)} </div>`
                    }
                },

            })
            this.select.on('load', (value, item) => {
      if (this.property.customer_properties.find(property=> (property.booking_id) ? property.booking_id : property.inquiry_id)){
          let booking_property  = this.property.customer_properties.filter(property=> (property.booking_id) ? property.booking_id : property.inquiry_id);
                    EventBus.$emit('onCustomerPropertySelected', booking_property);
        }
        else if(this.property.customer_properties.length == 1){
                this.$nextTick(() => {
                    EventBus.$emit('onCustomerPropertySelected', vm.property.customer_properties[0])
                });
        }
        if (this.property.customer_properties.find(property=> (property.is_default && property.customer_id == this.customerId) ? property.is_default : false)){
          let default_property  = this.property.customer_properties.filter(property=> (property.is_default && property.customer_id == this.customerId) ? property.is_default : false);
                    this.$nextTick(() => {
          EventBus.$emit('onCustomerPropertySelected', default_property);
                    });
                }
            })
        },
        initializeEventListeners() {
      this.select.on('item_add', (value) => {
        let property = this.property.customer_properties.find(property => property.customer_property_id == value);
        EventBus.$emit('onCustomerPropertySelected', property);
        this.select.clear(true);
        this.select.refreshOptions(true)
      })
        },
        initializeCustomerPropertyListeners() {
      EventBus.$on('onCustomerPropertyCreated', (data) => {
        if (data.property_id == this.property.property_id) {
                    this.select.addOption({
            value: data.customer_primary_field_vlaue,
            customer_property_id: data.customer_property_id
                    })
          this.property.customer_properties.push({
            value: data.customer_primary_field_vlaue,
            customer_property_id: data.customer_property_id,
            property_id: data.property_id
                        })
                    this.select.refreshOptions(false)
                }
            })
            EventBus.$on('onCustomerPropertyUpdated', (data) => {
        if (data.property_id == this.property.property_id) {
          this.select.removeOption(data.customer_property_id,)
                    this.select.addOption({
                        value: data.customer_primary_field_vlaue,
                        customer_property_id: data.customer_property_id
                    })
                    this.select.refreshOptions(false)
                }
            })
        },
        onFocusDropDown() {
            this.select.on('focus', () => {

        let focusedSelect = this.select.dropdown_content;

                $(this.select.dropdown_content).parent().show()
            })
        },
    },
    mounted() {
        this.initializeDropdown();
        this.initializeEventListeners()
        this.initializeCustomerPropertyListeners();
        this.onFocusDropDown();
        // this.selectCustomerPropertyIfSingleProperty()
  },
  watch: {
    propertyComputed(value) {

      this.select.clearOptions();
      if (value.customer_property_id){
      this.select.addOptions(value);
      if(value.customer_properties.length == 1){
        this.$nextTick(() => {
          EventBus.$emit('onCustomerPropertySelected', value.customer_properties[0])
        });
    }
      }
    }
  }

}
</script>

<style scoped lang="scss">
@import "bootstrap/scss/bootstrap";
@import "tom-select/dist/css/tom-select.min.css";
@import "tom-select/dist/css/tom-select.bootstrap5.min.css";
</style>